module.exports = __webpack_public_path__ + "img/violet_111.f31c18e7.png";